import { createLogic } from "redux-logic";
import type { SetInsuranceQuote } from "../actions/UscInsuranceActions";
import { INSURANCE_SET_QUOTE } from "../actions/UscInsuranceActions";
import { getSessionStorageParams, setInsuranceQuoteToStorage } from "../../utils/sessionStorage";
import { invalidateCode } from "../actions/UscSaveActions";
import type { UscLogicType } from "../store";

const insuranceSetQuoteLogic = (createLogic as UscLogicType<SetInsuranceQuote>)({
    type: INSURANCE_SET_QUOTE,

    process({ action, getState }, dispatch, done) {
        const currentState = getState();
        const { vehicle } = currentState;

        const vehicleForSaleId = vehicle.result?.id;

        const sessionStorageParams = getSessionStorageParams(currentState);
        if (vehicleForSaleId) setInsuranceQuoteToStorage(sessionStorageParams, action.quote, vehicleForSaleId);

        // Invalidate the tyCode as this includes insurance and should be refetched
        dispatch(invalidateCode());

        done();
    },
});

export default [insuranceSetQuoteLogic];
